import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BaseComponent } from 'src/app/components/forms/base-form/base-form.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent extends BaseComponent implements OnInit {

  uid: string = '';
  timestamp: string = '';
  hash: string = '';
  override successMessage: string = '';

  ngOnInit(): void {
    this.uid = this._activatedRoute.snapshot.paramMap.get('uid') ?? '';
    this.timestamp = this._activatedRoute.snapshot.paramMap.get('timestamp') ?? '';
    this.hash = this._activatedRoute.snapshot.paramMap.get('hash') ?? '';

    if (!this.uid || !this.timestamp || !this.hash) {
      this.errorMessage = 'This password reset link is invalid. Please request a new one.';
    }
  }

  override onSubmit(f: NgForm) {
    let values = f.form.value;

    if (values.new_pass !== values.confirm_pass) {
      this.errorMessage = 'The passwords do not match.';
      return;
    }

    this.errorMessage = '';
    this.displayProgressSpinner(true);

    this._authRESTService.reset_password(this.uid, this.timestamp, this.hash, values.new_pass)
      .subscribe(
        (data: any) => {
          this.displayProgressSpinner(false);
          if (data?.success) {
            this.successMessage = data.message;
          } else {
            this.errorMessage = data?.message ?? 'Unable to reset your password. Please request a new link.';
          }
        },
        error => this.handleError(error)
      );
  }

}
